import { appHttpClient } from "../../installations/http/axiosInterfaces";

export const login = (data) => {
  return appHttpClient.post(`/Account/Login`, data);
};

export const registerBusiness = (data) => {
  return appHttpClient.post(`/Account/Register/Business`, data);
};

export const resetUserPassword = (data) => {
  return appHttpClient.post(`/Account/ResetPassword/${data}`);
};

export const changeUserPassword = (data) => {
  return appHttpClient.post(`/Account/ChangePassword`, data);
};

export const getUserInfo = (data) => {
  return appHttpClient.get(`/Account/UserInfo`, {
    params: { token: data },
  });
};

export const getUsersByBusinessCustomer = () => {
  return appHttpClient.get(`/Account/UsersByBusinessCustomer`);
};

export const deleteAccount = (email) => {
  return appHttpClient.post(`/Account/DeleteUser/${email}`);
};

const accountService = {
  login,
  registerBusiness,
  resetUserPassword,
  changeUserPassword,
  getUserInfo,
  getUsersByBusinessCustomer,
  deleteAccount,
};

export default accountService;
